import { Radio as MantineRadio } from '@mantine/core';

export const Radio = MantineRadio.extend({});
